import _ from 'lodash';

export const DEFAULT_CONTROL_STYLES = (darkMode, isDisabled, colors) => ({
  minHeight: '34px',
  height: '36px',
  borderBottomWidth: '1px',
  border: darkMode ? 'inset 0 2px 4px 0 rgb(0 0 0 / 20%)' : '1px solid #ccc',
  boxShadow: 'inset 0 1px 1px rgba(0,0,0,.075)',
  cursor: 'text',
  color: isDisabled ? (darkMode ? '#2e3036' : '#2e3036') : darkMode ? '#dfe0e1' : '#333',
  background: isDisabled ? (darkMode ? colors.dark.bg : '#eeeeee') : darkMode ? '#2e3036' : '#ffffff',
  borderColor: 'rgba(103, 107, 118, 0.5)',
  '&:hover': {
    border: darkMode ? 'solid 1px rgba(103, 107, 118, 0.5)' : '1px solid #ccc',
  },
});

export const getOptions = (options, isGroup) => {
  if (_.isArray(options) && options.length) {
    if (isGroup && options[0].hasOwnProperty('label')) {
      return options;
    }
    if (options[0].hasOwnProperty('label') && options[0].hasOwnProperty('value')) {
      return options;
    }
  }
  return [];
};

export const getSelectedValue = (options, value) => {
  if (_.isArray(options)) {
    const newValue = _.isNull(value) ? '' : value;
    const findValue = options.find((option) => option.value === newValue);
    if (findValue) {
      return findValue;
    }
  }
  return new Error(`option not valid, ${typeof options}`);
};

export const getComponentsSelect = (components) => {
  if (components) {
    if (components.MenuList) {
      return _.omit(components, ['MenuList']);
    }
    return components;
  }
  return {};
};

export const getGroupSelectOptions = (isGroup, selectOptions) => {
  if (isGroup) {
    return selectOptions.reduce((accumulator, currentValue) => {
      if (currentValue.hasOwnProperty('options')) {
        accumulator.push(...currentValue.options);
      }
      return accumulator;
    }, []);
  }
  return selectOptions;
};

export const getMaxMenuHeight = (options, isGroup) => {
  const defaultHeight = 240;
  if (options && _.isArray(options)) {
    let optionsLength = options.length;
    if (isGroup) {
      const selectOptionsWithoutGroup = getGroupSelectOptions(isGroup, options);
      optionsLength = selectOptionsWithoutGroup.length;
    }
    return optionsLength && optionsLength < 9 ? optionsLength * 26 : defaultHeight;
  }
  return defaultHeight;
};

export const getScrollToIndex = (selectOptions, value, isGroup) => {
  const startScroll = 16;
  const options = getGroupSelectOptions(isGroup, selectOptions);
  if (options && options.length > startScroll && value) {
    const selectedValue = options.findIndex((option) => option.value.toString() === value.value.toString());
    if (!isGroup && selectedValue !== -1) {
      return selectedValue + 3;
    }
    // if (selectedValue !== -1) {
    //   if (isGroup) {
    //     return selectedValue - 5;
    //   }
    //   return selectedValue + (startScroll / 4);
    // }
  }
  return -1;
};

export const checkIsGroupSelect = (options) => !!(options && _.isArray(options) && options.length && options[0].hasOwnProperty('options'));
